<template lang="pug">
  .div
    .columns
      h3.title Valor del dólar
    .columns
      .column.is-6
        CardValores(:vu="valores")
    .columns
      .column.is-6
        .field
          label.label Valor Nuevo
            .control.has-icons-left.has-icons-right
              input.input.is-black(
                type='text', 
                placeholder='Valor Nuevo..',
                v-model="valorDolar_new",
                :disabled="isDisabled"
              )
    .columns
      .column.is-6
        .notification 
          strong Valor Unitario Nuevo: 
            | {{parseFloat(valorUnitario_new).toFixed(2)}}
    .columns
      a.button.is-black(@click="checkForm")
        | Guardar
    ModalDolar(v-show="modalStatus" :title="titleModal" :content="contentModal" @saveDolar="checkDolar")
</template>

<script>
  import CardValores from '../componentes/CardValores.vue'
  import ModalDolar from '../componentes/ModalDolar.vue'
  import sca_tuxpanServices from '@/services/sca/tpa.js' 

  export default {
    name: 'FormDolar',
    components: { CardValores, ModalDolar },
    data() {
      return {
        valorDolar_new: null,
        datosFaltantes: [],
        isDisabled: false,
        valores: {},
        valorUnitario_new: 0,
        titleModal: '',
        contentModal: '',
        modalStatus: false
      }
    },
    watch: {
      valorDolar_new() {
        this.valorUnitario_new = (0.55947 * this.valorDolar_new) / 3.785412
      }
    },
    methods: {
      iniciarComponente() {
        this.getValorActual()
      },
      checkForm() {
        if (this.valorDolar_new) {
          this.titleModal = 'Actualizar valor del dólar'
          this.contentModal = `¿Desea actualizar el valor del dólar a ${this.valorDolar_new}?`
          this.modalStatus = true
        } else {
          this.datosFaltantes.push('El valor es requerido.')
        }
      },
      guardar() {
        console.log('Guardar')
        sca_tuxpanServices.updateDolar(this.valorDolar_new, this.valorUnitario_new)
          .then( resp => {
            console.log(resp)
            if (resp.success) {
              let toast = this.$toasted.show(`El valor del dólar ha sido Actualizado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'done',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              this.$router.push('/TPA/SCA')
            } else {
              let toast = this.$toasted.show(`Error: ${resp.respuesta}`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch(e => console.log(e))
      },
      getValorActual () {
        sca_tuxpanServices.getValorUnitario()
          .then( res => {
            console.log(res)
            this.valores = res[0]
          })
          .catch(e => console.log(e))
      },
      checkDolar (result) {
        if (result) {
          console.log('Guardar')          
          this.guardar()
        } else {
          console.log('No hacer nada')
        }
        this.titleModal = ''
        this.contentModal = ''
        this.modalStatus = false

      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/FormDolar.vue